import React, {useEffect, useState} from "react";
import "./MenuSection.css";

var link = "a";

class MenuSection extends React.Component{

    constructor(props){ 
        super(props);
    }

    
    render(){
        return (
            <div className="MenuSection">
                <div className="menu-section">

                {this.props.text}
                <hr style={{color: "dimgray", borderColor: "dimgray", backgroundColor: "dimgray"}}></hr>             
                </div>
            </div>
        )
    }

    
}


export default MenuSection;
